function getFormatPhone(phone: string) {
  //test commit
  const phoneStr = phone
    .replace(/\D/g, '')
    
    const formattedPhoneStr = (phoneStr.startsWith('8') || phoneStr.startsWith('7')) ? phoneStr.slice(1) : phoneStr;

    return `+7 (${formattedPhoneStr.substring(0, 3)}) ${formattedPhoneStr.substring(3, 6)}-${formattedPhoneStr.substring(6, 8)}-${formattedPhoneStr.substring(8, 11)}`;
}

export default getFormatPhone
